<!-- =========================================================================================
  File Name: list.vue
  Description: Article List
========================================================================================== -->

<template>
  <div id="article-list">

    <vx-card title="文章列表">

      <div slot="actions">
        <vx-input-group>
          <template slot="prepend">
            <vs-button class="mr-4" size="small" color="success" type="filled" @click="add">添加新文章</vs-button>
          </template>
          <template slot="prepend">
            <vs-select class="w-48" v-model="typeVal">
              <vs-select-item :key="index" :value="index" :text="item" v-for="(item, index) in typeList" />
            </vs-select>
          </template>
          <vs-input class="w-48" v-model="keyword" placeholder="关键词" />
          <template slot="append">
            <div class="append-text bg-warning cursor-pointer" @click="search">
              <feather-icon icon="SearchIcon"></feather-icon>
            </div>
          </template>
        </vx-input-group>
      </div>

      <vs-table stripe :data="list" noDataText="暂无文章">
        <template slot="thead">
          <vs-th width="80">ID</vs-th>
          <vs-th width="120">分类</vs-th>
          <vs-th width="300">标题</vs-th>
          <vs-th width="150">时间</vs-th>
          <vs-th width="150">操作</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="index" v-for="(item, index) in list" >
            <vs-td :data="item.id">{{item.id}}</vs-td>
            <vs-td :data="item.type">{{typeList[item.type]}}</vs-td>
            <vs-td :data="item.title">{{item.title}}</vs-td>
            <vs-td :data="item.date">{{item.date}}</vs-td>
            <vs-td>
              <vs-button color="primary" type="filled" size="small" @click="modify" :data-index="index" class="ml-4">编辑</vs-button>
              <vs-button color="danger" type="border" size="small" @click="del" :data-index="index" class="ml-4">删除</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <vs-pagination class="mt-6" :total="totalPage" v-model="page" goto />
    </vx-card>

    <!-- 更改侧边栏-->
    <modify-sider-bar ref="modifySiderBar" :title="modifyIndex != -1 ? '更改文章' : '添加文章'" @confirm="submit">
      <div class="p-4">
        <div class="mb-4">
          <vs-input class="w-full" v-model="modifyItem.title" label="文章标题" />
        </div>
        <div class="mb-4">
          <vs-select class="w-full" v-model="modifyItem.type" label="文章类型">
            <vs-select-item :key="index" :value="index" :text="item" v-for="(item, index) in typeList" />
          </vs-select>
        </div>
        <div class="mb-4">
          <vs-input class="w-full" v-model="modifyItem.date" label="发布时间" />
        </div>
        <div>
          <quill-editor v-model="modifyItem.content" v-if="isLoaded" :options="{ modules: { toolbar: '#toolbar' } }">
            <div id="toolbar" slot="toolbar">
              <!-- Add a bold button -->
              <button class="ql-bold">Bold</button>
              <button class="ql-italic">Italic</button>
              <button class="ql-underline">Underline</button>
              <select class="ql-color"></select>
              <select class="ql-size">
                <option value="small">字体 - 小</option>
                <option selected>字体 - 中</option>
                <option value="large">字体 - 大</option>
                <option value="huge">字体 - 巨大</option>
              </select>
              <select class="ql-font">
                <option selected="selected">系统字体</option>
                <option value="SimSun">宋体</option>
                <option value="KaiTi">楷体</option>
                <option value="SimHei">黑体</option>
                <option value="Microsoft YaHei">微软雅黑</option>
              </select>
              <select class="ql-align"></select>
              <button class="ql-script" value="sub"></button>
              <button class="ql-script" value="super"></button>
              <button class="ql-link"></button>
              <button class="ql-image"></button>
            </div>
          </quill-editor>
        </div>
      </div>
    </modify-sider-bar>
  </div>
</template>

<script>

import { quillEditor } from 'vue-quill-editor'
import modifySiderBar from '../../layouts/components/modifySiderBar.vue'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  data() {
    return {
      keyword: '',
      page: 1,
      totalPage: 1,
      list: [],
      modifyIndex: 0,
      modifyItem: {},
      typeList: {},
      typeVal: '',
      isLoaded: false,
      date: ''
    }
  },
  components: {
    modifySiderBar, quillEditor
  },
  methods: {
    add () {
      this.modifyIndex = -1
      this.modifyItem = {}
      this.modifyItem.type = ''
      this.modifyItem.date = this.date
      this.$refs.modifySiderBar.open()
    },
    modify (e) {
      this.modifyIndex = e.currentTarget.dataset.index
      this.modifyItem = JSON.parse(JSON.stringify(this.list[parseInt(this.modifyIndex)]))
      this.$refs.modifySiderBar.open()
    },
    submit () {
      const postdata = JSON.parse(JSON.stringify(this.modifyItem))
      postdata.authKey = localStorage.getItem('authKey')
      this.$utils.post(this.modifyIndex === -1 ? 'article-add' : 'article-update', postdata).then(res => {
        this.$vs.dialog({
          title: '提示',
          text: res,
          acceptText: '确认'
        })
        this.load()
        this.$refs.modifySiderBar.close()
      })
    },
    del (e) {
      const index = e.currentTarget.dataset.index
      const postdata = {}
      postdata.id = this.list[index].id
      postdata.authKey = localStorage.getItem('authKey')
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '确认',
        text: '确认删除该文章吗?',
        acceptText: '确认',
        cancelText: '取消',
        accept: () => {
          this.$utils.post('article-delete', postdata).then(res => {
            this.$vs.dialog({
              title: '提示',
              text: res,
              acceptText: '确认'
            })
            this.list.splice(index, 1)
          })
        }
      })
    },
    search() {
      this.page = 1
      this.load()
    },
    load() {
      const postdata = {}
      postdata.authKey = localStorage.getItem('authKey')
      postdata.type = this.typeVal
      postdata.keyword = this.keyword
      postdata.page = this.page
      this.$utils.post('article-list', postdata).then(res => {
        this.list = res.list
        this.totalPage = Math.ceil(res.count / res.pagesize)
        this.isLoaded = true
      })
    }
  },
  watch: {
    page(newValue) {
      this.page = newValue
      this.load()
    }
  },
  mounted () {
    this.load()

    // 获取分类列表
    this.$utils.post('article-typeList', { authKey: localStorage.getItem('authKey') }).then(res => {
      this.typeList = { '': '文章分类' }
      for (const i in res) {
        this.typeList[i] = res[i]
      }
    })

    // 获取时间
    const date = new Date()
    this.date = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
  }
}
</script>

<style>
  .ql-tooltip {
    left: 0 !important;
  }
</style>
